import React from 'react';
import { useShowContext } from 'ui-builder';
import { AbstractTask, TaskType } from 'nekst-api';
import { BaseTaskRowAssignmentWidget } from 'features/nekst-widgets';

export function InvitationRecipients() {
  const showContext = useShowContext<AbstractTask>();

  if (showContext.data?.type === TaskType.EVENT) {
    return (
      <BaseTaskRowAssignmentWidget
        source="inviteRecipients"
        filterFunc={() => true}
        label=""
        getNameFunc={(item) => item._profile.name.fullName || ''}
        getImageFunc={(item) => item._profile._avatarUrl?.resized}
      />
    );
  } else {
    return null;
  }
}
